import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";
import { Section } from "../components/ui";

export function NotFound() {
  return (
    <main className="relative z-10 pt-32 pb-24 min-h-[60vh] flex items-center">
      <Seo
        title="Página não encontrada | P2A Marketing & Branding"
        description="A página que você procura não existe ou foi movida."
        path="/404"
        noindex
      />
      <Section className="text-center">
        <h1 className="text-4xl md:text-6xl font-black uppercase tracking-tighter mb-6">
          Página não <span className="font-highlight italic text-brand-accent lowercase font-normal">encontrada</span>
        </h1>
        <p className="text-xl text-brand-light/70 max-w-xl mx-auto mb-10">
          O endereço que você tentou acessar não existe ou foi movido.
        </p>
        <Link
          to="/"
          className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-brand-dark bg-brand-accent rounded-full hover:bg-brand-light transition-colors"
        >
          Voltar para a home
        </Link>
      </Section>
    </main>
  );
}
